/**
 * @file legal-limits.ts
 * @description Пределы юридических документов магазина (phase19.16, партия
 * «Юридические документы» SB139–SB144; проект данных
 * docs/phases/phase19.16-materials/db-design-legal-docs.md §1.2, §3.2, §6).
 *
 * Зачем в shared: одни и те же числа читают API (FileInterceptor, проверка
 * DTO, обрезка имени файла), кабинет (подсказка «до 20 МБ», счётчик знаков
 * описания, предупреждение после трёх своих строк подвала) и витрина.
 * Длины совпадают с колонками БД (VARCHAR(500), VARCHAR(150), VARCHAR(300)) —
 * расхождение дало бы 500 вместо понятной 400/422.
 */

import { SITE_THEME_LIMITS } from "../site-theme/theme-limits.js";

/** SB139: наибольший размер PDF-файла документа, байт (20 МиБ). */
export const LEGAL_PDF_MAX_BYTES = 20 * 1024 * 1024;

/** Адрес документа `/legal/<адрес>`: длина (как в прежнем DTO api). */
export const LEGAL_SLUG_MAX_LENGTH = 60;

/** Название документа или группы (как в прежнем DTO api). */
export const LEGAL_TITLE_MAX_LENGTH = 200;

/** Краткое описание: `LegalDocument.description VARCHAR(500)`; у PDF обязательно (SB139). */
export const LEGAL_DESCRIPTION_MAX_LENGTH = 500;

/** Имя файла PDF: `draftFileName` / `fileName VARCHAR(150)`, как обрезка в stored-file-response. */
export const LEGAL_FILE_NAME_MAX_LENGTH = 150;

/** Служебная заметка редакции: `LegalDocumentRevision.note VARCHAR(300)`. */
export const LEGAL_REVISION_NOTE_MAX_LENGTH = 300;

/** Сколько редакций отдаёт одна страница истории (`GET /:id/revisions?limit=`). */
export const LEGAL_REVISIONS_PAGE_SIZE = 20;

/**
 * SB142: после стольких включённых своих строк блока «Ссылки» подвала —
 * мягкое предупреждение (не запрет). Число — из пределов темы (одно место);
 * жёсткий предел схемы — `FOOTER_DOCS_MAX` (site-theme/footer-docs.ts).
 */
export const FOOTER_DOCS_SOFT_LIMIT: number = SITE_THEME_LIMITS.footerDocs.warnAbove;

/**
 * SB143, SB54: прежние редакции хранятся не меньше 3 лет после замены
 * (ГК ст. 196); на практике — бессрочно, код их не удаляет.
 */
export const LEGAL_REVISION_RETENTION_YEARS = 3;
